// extracted by mini-css-extract-plugin
export default {"ChannelList":"ChannelList_ChannelList__Z-wS4"};